function onlyOneSelected() {
    return function (control, { componentIds, componentProps, screenId }) {
        // if only one selected
        if (!componentIds || componentIds.length !== 1) {
            return null
        }
        return true
    }
}

function groupSelected() {
    return function (control, { componentIds, componentProps, screenId }) {
        return !!(componentIds && componentIds.length > 1)
    }
}

function onlyOneSelectedAndHasTag(tag) {
    return function (control, { componentIds, componentProps, screenId }) {
        // if only one selected
        if (!componentIds || componentIds.length !== 1) {
            return null
        }
        // check if component has specific tag
        const props = componentProps[componentIds[0]]
        return props && props.tags && props.tags.indexOf(tag) >= 0
    }
}

function onlyOneSelectedAndDataEqual(data) {
    return function (control, { componentIds, componentProps, screenId }) {
        // if only one selected
        if (!componentIds || componentIds.length !== 1) {
            return false
        }
        // check if component has specific tag
        const props = componentProps[componentIds[0]]
        if (props && props.data) {
            for (let key in data) {
                if (props.data[key] !== data[key]) {
                    return false
                }
            }
            // all data fields are equal
            return true
        }
        return false
    }
}

function onlyOneSelectedAndDisplayNameNotEqual(displayName) {
    return function (control, { componentIds, componentProps, screenId }) {
        // if only one selected
        if (!componentIds || componentIds.length !== 1) {
            return null
        }

        if (displayName && componentProps[componentIds[0]].displayName === displayName) {
            return false
        }

        return true
    }
}

export default {
    onlyOneSelected,
    groupSelected,
    onlyOneSelectedAndHasTag,
    onlyOneSelectedAndDataEqual,
    onlyOneSelectedAndDisplayNameNotEqual,
}
